<script context="module" lang="ts">
  export type CrossIconButtonVariant = Extract<IconButtonVariants, "tertiary" | "theme-agnostic">;
</script>

<script lang="ts">
  import IconButton, {
    type IconButtonSizes,
    type IconButtonVariants,
  } from "$components/+design-system/IconButton/IconButton.svelte";
  import { Cross } from "./OVIcon";

  export let position: string = "top-2 right-2";
  export let variant: CrossIconButtonVariant = "tertiary";
  export let a11yLabel: string = "Close";
  export let size: IconButtonSizes = "medium";
</script>

<div class="absolute {position} z-button">
  <IconButton on:click {a11yLabel} {variant} {size} icon={Cross} />
</div>
